import { Component, input, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ProductionKeyPerformanceIndicatorEvaluation } from 'src/app/models/production-key-performance-indicator-evaluation.model';
import {
  RegisteredWorkComplianceCategorySummary,
  RegisteredWorkComplianceEvaluatorData,
  RegisteredWorkComplianceWeek,
} from 'src/app/models/registered-work-compliance-kpi-data.model';
import { RegisteredWorkComplianceWeeksDialogComponent } from './registered-work-compliance-weeks-dialog/registered-work-compliance-weeks-dialog.component';
import { createKpiDetailsDialogConfig } from 'src/app/components/main/employees/performance/my-metrics/kpi-details-dialog/kpi-details-dialog.config';

@Component({
  selector: 'app-registered-work-compliance-details',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './registered-work-compliance-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './registered-work-compliance-details.component.css',
})
export class RegisteredWorkComplianceDetailsComponent {
  private readonly dialog = inject(MatDialog);

  currentMonthEvaluation = input<ProductionKeyPerformanceIndicatorEvaluation | null>(null);

  private readonly evaluatorData = computed<RegisteredWorkComplianceEvaluatorData | null>(
    () => (this.currentMonthEvaluation()?.data as RegisteredWorkComplianceEvaluatorData | undefined) ?? null
  );

  // Solo productos: barras azules neutras con el total del mes en curso
  companyProductSummaries = computed<RegisteredWorkComplianceCategorySummary[]>(() => {
    const company_products = this.evaluatorData()?.company_product_summaries;

    if (!company_products?.length) {
      return [];
    }

    return company_products.filter(company_product => RegisteredWorkComplianceDetailsComponent.isCategorySummary(company_product));
  });

  weeks = computed<RegisteredWorkComplianceWeek[]>(() => this.evaluatorData()?.weeks ?? []);

  // no es signal porque el dialog se abre solo al hacer click
  openWeeksDialog(): void {
    const weeks = this.weeks();

    if (!weeks.length) {
      return;
    }

    this.dialog.open(RegisteredWorkComplianceWeeksDialogComponent, createKpiDetailsDialogConfig({ weeks }));
  }

  private static isCategorySummary(value: unknown): value is RegisteredWorkComplianceCategorySummary {
    if (typeof value !== 'object' || value === null) {
      return false;
    }

    const candidate = value as Partial<RegisteredWorkComplianceCategorySummary>;

    return (
      typeof candidate.name === 'string' &&
      typeof candidate.expected_hours === 'number' &&
      typeof candidate.done_hours === 'number' &&
      typeof candidate.percentage === 'number'
    );
  }
}
